import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { Icon } from '../../../types/icon.type';
import { MatIconModule } from '@angular/material/icon';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'immo-icon-button',
  imports: [
    MatRippleModule,
    MatIconModule
  ],
  templateUrl: './icon-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './icon-button.component.css',
})
export class IconButtonComponent extends BaseComponent {

  // -----------------------------------------------------------------------------------------------------
  // @ INPUTS
  // -----------------------------------------------------------------------------------------------------

  readonly icon = input.required<Icon>();

  // -----------------------------------------------------------------------------------------------------
  // @ OUTPUTS
  // -----------------------------------------------------------------------------------------------------
  
  readonly clicked = output<void>();
}
